import { LoggingGateway } from './logging.gateway'
import { ErrorReportGateway } from './error-report.gateway'

/**
 * ErrorBoundaryComponent only catches errors thrown during render — anything
 * thrown from an event handler, a timer, or a rejected promise never reaches
 * it. This is the other half of tier 3: a last-resort net for those. Same
 * "new the gateway directly, no DI" reasoning as the boundary — must still
 * work if the container itself is what's broken.
 */
export function installGlobalErrorLogging(): void {
  const logging = new LoggingGateway()
  const report = new ErrorReportGateway()

  window.addEventListener('error', (event) => {
    logging.error('Unhandled error', { message: event.message, stack: event.error?.stack })
    report.report(event.message, event.error?.stack)
  })

  window.addEventListener('unhandledrejection', (event) => {
    const reason = event.reason
    const message = reason instanceof Error ? reason.message : String(reason)
    const stack = reason instanceof Error ? reason.stack : undefined
    logging.error('Unhandled promise rejection', { message, stack })
    report.report(`Unhandled promise rejection: ${message}`, stack)
  })
}
